import { User } from '@griply/types';
import { useQuery } from '@tanstack/react-query';
import { createSubscriptionDoc } from 'shared/lib/@tanstack-query';
import { getUserRef } from 'shared/services/backend-api';

export const queryKey = 'user';

type Select<TSelected> = (data: User | null | undefined) => TSelected;

export type UseUserQueryOptions<TSelected = User | null | undefined> = {
  select?: Select<TSelected>;
};

export const useUserQuery = <TSelected = User | null | undefined>(
  options?: UseUserQueryOptions<TSelected>,
) =>
  useQuery({
    queryKey: [queryKey],
    queryFn: async (context) => {
      const userRef = await getUserRef();

      if (!userRef) {
        return null;
      }

      // The rules gate this doc on the caller's own uid, so denied means the session is gone, not a fault.
      return createSubscriptionDoc(() => userRef, {
        expectedErrorCodes: ['permission-denied'],
      })(context);
    },
    select: options?.select,
  });
